module.exports = __webpack_public_path__ + "img/prompt.fd117dab.png";